// extracted by mini-css-extract-plugin
module.exports = {"tablist":"styles_tablist__1TO74","tab":"styles_tab__2RFRd","selected":"styles_selected__c2dVH"};